import { SubscriptionCredentialsMapper } from '@nx-smartmonkey/shared/domain';

import { PlannerCredentials } from '../../domain/credentials/PlannerCredentials';
import { PlannerCredentialsDTO } from '../../domain/credentials/PlannerCredentialsDTO';
import { ProjectCredentialsListMapper } from './ProjectCredentialsListMapper';

export class PlannerCredentialsMapper {
  static toDomain(props: PlannerCredentialsDTO): PlannerCredentials {
    const { id, meta, organization_id, permissions, projects, roles, subscription } = props;

    return PlannerCredentials.create({
      id,
      meta,
      organization_id: organization_id,
      permissions: permissions,
      roles,
      projects: ProjectCredentialsListMapper.toDomain({ projects }),
      subscription: SubscriptionCredentialsMapper.toDomain(subscription),
    });
  }
}
